import React, { useEffect } from 'react';
import styled from 'styled-components';

import { commonEvents } from '../../../../../constants/event';
import { dimensionTypes } from '../../../../../constants/retention';
import RetentionDimensionSelect from '../../../../retention/RetentionDimensionSelect';
import RetentionExecutionOptionsBar from '../../../../../containers/dashboards/cards/builder/retentionSimple/RetentionExecutionOptionsBar';

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  margin-bottom: 24px;
  position: relative;
`;

const dtToReturnEventMappings = {
  [dimensionTypes.DAILY]: commonEvents.DAU,
  [dimensionTypes.WEEKLY]: commonEvents.WAU,
  [dimensionTypes.MONTHLY]: commonEvents.MAU,
};

const onDimensionTypeChangeCompose = (dt, onReturnEventChange, onDimensionTypeChange) => {
  onReturnEventChange(dtToReturnEventMappings[dt]);
  onDimensionTypeChange(dt);
};

const RetentionSimplifiedComposeContainer = ({
  selectedDimensionType,
  onReturnEventChange,
  onFirstEventChange,
  onDimensionTypeChange,
  unitId,
}) => {
  const dimensionType = selectedDimensionType || dimensionTypes.DAILY;

  useEffect(() => {
    onFirstEventChange(commonEvents.REGISTER_FIRST_START);
    onReturnEventChange(dtToReturnEventMappings[dimensionType]);
    onDimensionTypeChange(dimensionType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledDiv>
      <RetentionDimensionSelect
        dimensionType={dimensionType}
        onDimensionTypeChange={(dt) =>
          onDimensionTypeChangeCompose(dt, onReturnEventChange, onDimensionTypeChange)
        }
      />
      <RetentionExecutionOptionsBar unitId={unitId} />
    </StyledDiv>
  );
};

export default RetentionSimplifiedComposeContainer;
